var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "24", height: "22", viewBox: "0 0 24 22", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement(
      "g",
      { id: "message-icon-Symbols", fill: "none", fillRule: "evenodd" },
      React.createElement(
        "g",
        { id: "message-icon-Icon/Messages/24", transform: "translate(0 -1)", fill: "#1A1A1A", fillRule: "nonzero" },
        React.createElement("path", { d: "M23.25 1.071a.75.75 0 0 1 .75.75v15a.75.75 0 0 1-.75.75H6.418L1.28 22.71a.75.75 0 0 1-1.28-.53V1.82a.75.75 0 0 1 .75-.75h22.5zm-.75 1.5h-21v17.797l4.077-4.077a.75.75 0 0 1 .53-.22H22.5v-13.5zM15 10.714a.75.75 0 1 1 0 1.5H6a.75.75 0 1 1 0-1.5zm3-4.286a.75.75 0 1 1 0 1.5H6a.75.75 0 0 1 0-1.5z", id: "message-icon-Combined-Shape" })
      )
    )
  );
});


// WEBPACK FOOTER //
// ./src/routers/Desktop/NavBar/components/icons/Messages.svg